export default __webpack_public_path__ + "static/77-b4790c7a4928d24b7ccb5b7446d457c6.gif";